import { api } from "../api";

/* ================================
   UPLOAD PRODUTO
================================ */

export async function uploadImagemProduto(
  produtoId: string,
  file: File,
): Promise<{ key: string }> {
  const extensao = file.type.split("/").pop();

  try {
    /* ================================
       URL ASSINADA
    ================================ */

    const response = await api.post(
      `/products/${produtoId}/images/upload-url`,
      {
        fileExtension: extensao,
      },
    );

    const { uploadUrl, key } = response.data;

    /* ================================
       UPLOAD S3
    ================================ */

    const uploadResponse = await fetch(uploadUrl, {
      method: "PUT",
      headers: {
        "Content-Type": file.type,
      },
      body: file,
    });

    if (!uploadResponse.ok) {
      throw new Error(`Erro upload S3: ${uploadResponse.status}`);
    }

    return { key };
  } catch (error: any) {
    console.error("ERRO NO UPLOAD:", error);

    console.error("STATUS:", error.response?.status);

    console.error("BODY:", error.response?.data);

    throw error;
  }
}
